// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"be031655","46":"8dbb8b0b","226":"a998bd96","228":"64511bd1","281":"d464b36c","286":"2edb7b16","358":"d5d0585d","529":"c1e7771f","621":"b570c3e7","707":"43441aea","840":"b5a9fa43","973":"682fe98a"}[chunkId] + ".chunk.js";
};